import Footer from "../components/Footer";
import Header from "../components/Header";

const TermsAndCondition = () => {
  return (
    <div>
      <Header />
      <section className="hero-section-about d-flex align-items-center">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 hero-content offset-lg-3 text-center">
              <span className="portfolio-hero-subtitle">Terms and Conditions</span>
              <div className="hedding process-underline-flex justify-content-center">
                <div className="process-underline"></div>
                <div className="process-underline"></div>
              </div>
              <p className="about-title">
                At Hope Web Solutions, we believe that a strong online presence is the key to unlocking your business's full potential. Founded with a passion for creativity and technology, we specialize in delivering innovative, customized web solutions that help businesses of all sizes grow and thrive in the digital world.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="terms-section py-5" style={{ background: "#fff", color: "#222" }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="terms-content">
                <div className="terms-block mb-2 p-2">
                  <h3 className="fw-bold mb-2" style={{ color: "#111" }}>
                    Introduction
                  </h3>
                  <p className="mb-0" style={{ color: "#444" }}>
                    Welcome to Hope Web Solutions. By accessing or using our website (www.hopewebsolutions.com), you agree to comply with and be bound by the following Terms and Conditions. If you do not agree, please do not use this website.
                  </p>
                </div>

                <div className="terms-block mb-2 p-2">
                  <h3 className="fw-bold mb-2" style={{ color: "#111" }}>
                    1. Intellectual Property
                  </h3>
                  <p className="mb-0" style={{ color: "#444" }}>
                    All trademarks, logos, and content on this website are owned or licensed by Hope Web Solutions. You may not use them without written approval.
                  </p>
                </div>

                <div className="terms-block mb-2 p-2">
                  <h3 className="fw-bold mb-2" style={{ color: "#111" }}>
                    2. Website Usage
                  </h3>
                  <p className="mb-0" style={{ color: "#444" }}>
                    You agree to use the website for lawful purposes only. You must not engage in any activity that could damage, disable, or impair the website or interfere with others' use.
                  </p>
                </div>

                <div className="terms-block mb-2 p-2">
                  <h3 className="fw-bold mb-2" style={{ color: "#111" }}>
                    3. Intellectual Property Rights
                  </h3>
                  <p className="mb-0" style={{ color: "#444" }}>
                    All content, graphics, designs, text, logos, and other materials on the website are the property of Hope Web Solutions or its licensors. Unauthorized use or reproduction is strictly prohibited.
                  </p>
                </div>

                <div className="terms-block mb-2 p-2">
                  <h3 className="fw-bold mb-2" style={{ color: "#111" }}>
                    4. External Links
                  </h3>
                  <p className="mb-0" style={{ color: "#444" }}>
                    We may provide links to third-party websites for convenience or reference. We do not endorse, and are not responsible for, the content, availability, or privacy practices of such sites.
                  </p>
                </div>

                <div className="terms-block mb-2 p-2">
                  <h3 className="fw-bold mb-2" style={{ color: "#111" }}>
                    5. Disclaimer of Warranties
                  </h3>
                  <p className="mb-0" style={{ color: "#444" }}>
                    We do not guarantee that the website will be error-free or uninterrupted. All information is provided "as is" without warranties of any kind, express or implied.
                  </p>
                </div>

                <div className="terms-block mb-2 p-2">
                  <h3 className="fw-bold mb-2" style={{ color: "#111" }}>
                    6. Limitation of Liability
                  </h3>
                  <p className="mb-0" style={{ color: "#444" }}>
                    Hope Web Solutions shall not be liable for any direct, indirect, incidental, or consequential damages arising from your use of this website.
                  </p>
                </div>

                <div className="terms-block mb-2 p-2">
                  <h3 className="fw-bold mb-2" style={{ color: "#111" }}>
                    7. Modification of Terms
                  </h3>
                  <p className="mb-0" style={{ color: "#444" }}>
                    We reserve the right to change or update these terms at any time. Continued use of the website after changes are posted constitutes acceptance.
                  </p>
                </div>

                <div className="terms-block mb-2 p-2">
                  <h3 className="fw-bold mb-2" style={{ color: "#111" }}>
                    8. Governing Law
                  </h3>
                  <p className="mb-0" style={{ color: "#444" }}>
                    These terms shall be governed in accordance with the laws of [Insert State/Country], and any disputes will be resolved under its jurisdiction.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default TermsAndCondition;
